import { ComponentCanDeactivate } from './component-can-deactivate';
import { UntypedFormArray } from "@angular/forms";
import { Directive } from "@angular/core";

@Directive()
export abstract class FormCanDeactivate extends ComponentCanDeactivate {

  abstract get formArray(): UntypedFormArray;

  canDeactivate(): boolean {
    return !this.formArray.dirty;
  }
}
